<template>
  <div>
    <vs-card>
      <b-row>
        <b-col cols="12" md="auto"><b-form-input v-model="searching" @keyup.enter="filterStockList()" id="smallInput"
            placeholder="Ara" />
        </b-col>
        <b-col cols="12" md="auto">
          <b-button style="  border-color:white !important;" v-on:click="filterStockList()" id="loading-stockList2"
            class="bg-primary-gradient vs-con-loading__container">
            <Icon icon="clarity:search-line" width="20" height="20" v-b-tooltip.hover.bottom="'Listele/Ara'" />
          </b-button>
        </b-col>
        <b-col cols="12" md="auto">
          <vs-button style="border-radius: 5px" color="success" type="gradient" id="button-with-loading"
            class="  vs-con-loading__container" @click="islemiTamamla()">İşlemi
            Tamamla</vs-button>
        </b-col>
        <b-col cols="12" md="auto">
          <vs-button style="border-radius: 5px" type="gradient" id="button-with-loading"
            class="  vs-con-loading__container" @click="cekiListForExcel()">Excel
            işlemleri</vs-button>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <vs-button size="small" @click="resetFilter" style="margin-top: 25px;  border-radius: 3px" color="purple"
        type="filled">Filtreyi
        Resetle</vs-button>
      <vs-table v-model="selected" stripe :data="veriler" :selected.sync="selectedRow" @dblSelection="doubleSelection">
        <template slot="thead">
          <vs-th sort-key="stokkodu">Sipariş Tarihi</vs-th>
          <vs-th sort-key="orderNumber">Sipariş No</vs-th>
          <vs-th sort-key="yenibarcode"></vs-th>
          <vs-th sort-key="productName">Ürün Adı</vs-th>
          <vs-th sort-key="sku">Stok Kodu/Barkod</vs-th>
          <vs-th sort-key="price">Fiyat</vs-th>
          <vs-th sort-key="quantity">Sipariş Miktarı</vs-th>
          <vs-th sort-key="quantity">Sevk Miktarı</vs-th>

          <vs-th sort-key="gonderilen">Gönderilen Miktar</vs-th>
          <vs-th sort-key="kalanAdet">Kalan Miktar</vs-th>

          <vs-th sort-key="hazirlanan">Hazırlanan</vs-th>

          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in  data ">
            <vs-td :data="data[indextr].siparisTarihi">
              {{ formatTarih(data[indextr].siparisTarihi) }}
            </vs-td>
            <vs-td :data="data[indextr].orderNumber">
              {{ data[indextr].orderNumber }}
              {{ data[indextr].program }}
              {{ data[indextr].invoiceLastName }}
              {{ data[indextr].barcode }}
            </vs-td>
            <vs-td :data="data[indextr].yenibarcode">
            </vs-td>
            <vs-td :data="data[indextr].productName">
              {{ data[indextr].productName }}
            </vs-td>
            <vs-td :data="data[indextr].sku">
              <b-row>
                <vs-chip color="#24c1a0">
                  {{ data[indextr].hazirlananKoliAdet }} Koli - {{ data[indextr].hazirlananKoliIci }} Adet
                </vs-chip>
              </b-row>


              <b-row v-if="data[indextr].cargoTagNumber">
                <b-col cols="2" v-for="(value, index) in data[indextr].cargoTagNumber.split(',')"
                  v-on:click="printBarcode('control', tr, value)">
                  <vs-chip color="primary">
                    {{ value }}
                  </vs-chip>
                </b-col>
              </b-row>
            </vs-td>
            <vs-td :data="data[indextr].price">
              {{ data[indextr].price }} TL
            </vs-td>
            <vs-td :data="data[indextr].quantity">
              {{ data[indextr].quantity }}
            </vs-td>
            <vs-td :data="data[indextr].sevkMiktari">
              {{ data[indextr].sevkMiktari }}
            </vs-td>
            <vs-td :data="data[indextr].gonderilen">
              {{ data[indextr].gonderilen }}
            </vs-td>
            <vs-td :data="data[indextr].kalanAdet">
              {{ data[indextr].kalanAdet }}
            </vs-td>
            <vs-td :data="data[indextr].hazirlanan">
              {{ data[indextr].hazirlanan }}
            </vs-td>


            <vs-td :data="data[indextr].KoliAdet" style="">
              Koli: <span v-if="!data[indextr].KoliAdetDeger">
                {{ yuvarla(data[indextr].siparisOnay / data[indextr].KoliAdet) }} </span>
              <span v-else>{{ data[indextr].KoliAdetDeger }} </span>
              , Adedi:{{ data[indextr].KoliAdet }}
              <b-row style="margin-top: 15px; min-width: 235px;">

                <b-col style="padding: 0px;">
                  <vs-chip
                    :color="(data[indextr].kalanAdet - (data[indextr].KoliAdetDeger * data[indextr].KoliAdet)) > 0 ? 'danger' : 'success'">
                    {{ data[indextr].kalanAdet - (data[indextr].KoliAdetDeger * data[indextr].KoliAdet) }}
                  </vs-chip>

                  <vs-button @click="openPopup(tr)" color="rgb(5, 111, 190)" type="filled"
                    style="font-size: 5px; padding: 5px !important" size="small">
                    <Icon icon="ep:box" width="20" height="20" />
                  </vs-button>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <input v-model="data[indextr].siparisOnay" style="width: 35px;"
                        @input="yuvarlananVeCarpilan(data[indextr].siparisOnay, data[indextr].KoliAdet, indextr)" />
                    </b-col>
                    <b-col>
                      <vs-button @click="addCekiList2(data[indextr])" type="filled"
                        style="font-size: 5px; padding: 5px !important" size="small" color="danger">
                        <Icon style="margin-right: 5px" icon="bi:send-fill" width="20" height="20"
                          v-b-tooltip.hover.bottom="' Gönder'" />
                      </vs-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <vs-button @click="barkodPopup(tr)" color="warning" type="filled"
                    style="font-size: 5px; padding: 5px !important" size="small">
                    <Icon icon="material-symbols:barcode" width="20" height="20" />
                  </vs-button>
                </b-col>
              </b-row>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>

    <vs-popup classContent="popup-example" title="Koli Barkodları" :active.sync="popupActivo" v-if="selectedRow">
      <!-- Barcode section -->
      <b-list-group>
        <vs-button style="border-radius: 3px" type="gradient" color="success" @click="printAllBarcodes()">
          Tümünü Yazdır
        </vs-button>
        <b-list-group-item>
          <vs-card v-for="( barcode, index ) in  selectedRow.KoliBarcodes " :key="index" :col="auto" class="border">
            <div class="border-item">
              <vs-th sort-key="orderNumber">Sipariş No</vs-th>
              <p>{{ selectedRow.orderNumber }}</p>
            </div>
            <div class="border-item">

              <vs-th sort-key="barcode">Barcode </vs-th>
              <p>{{ selectedRow.barcode }}</p>
            </div>
            <div class="border-item">
              <vs-th sort-key="siparisTarihi">Sipariş Tarihi</vs-th>
              <p>{{ formatTarih(selectedRow.siparisTarihi) }}</p>
            </div>
            <div class="border-item">
              <vs-th sort-key="program">Program</vs-th>
              <p>{{ selectedRow.program }}</p>
            </div>

            <div class="border-item">
              <vs-th sort-key="productName">Ürün Adı</vs-th>
              <p>{{ selectedRow.productName }}</p>
            </div>
            <div class="border-item">
              <vs-th sort-key="productName">Koli Barkodu:</vs-th>
              <p>{{ barcode }}</p>
            </div>
            <div class="border-item">
              <vs-th sort-key="productName">Koli Numarası:</vs-th>
              <b-form-input v-model="selectedRow.KoliBarcodesNumber[index]" id="smallInput" placeholder="Ara" />
            </div>

            <div>
              <b-row>
                <b-col>
                  <barcode :value="selectedRow.barcode" format="CODE128" :width="2" :height="30" />
                </b-col>

              </b-row>
              <vs-button style="border-radius: 3px" type="gradient" color="success" @click="printBarcode(index)">
                Yazdır
              </vs-button>
              <br>
              <br>
            </div>
          </vs-card>
        </b-list-group-item>
      </b-list-group>
      <barcodeYazdir :barcodeData="[generatedBarcodes[selectedBarcodeIndex]]" :selectedRow="selectedRow"
        :koliNumber="koliNumber" ref="barcodeYazdir"></barcodeYazdir>
    </vs-popup>
    <barcodeYazdir :barcodeData="[generatedBarcodes[selectedBarcodeIndex]]" :selectedRow="selectedRow"
      ref="barcodeYazdir"></barcodeYazdir>
    <KoliEklePopup :isSidebarActiveKoli="popupActivo2" :data="selectedRowKoli" @closeSidebar="popupClose" />
    <CekiListForExcel :isSidebarActive="excelPopupActive" @closeSidebar="toggleDataSidebar"
      :sevkNumber="orderSevkNumber" />

  </div>
</template>

<script>
import Barcode from 'vue-barcode';
import KoliEklePopup from '../components/uzum-components/paketleme-components/KoliEklePopup.vue';
import SiparisDetayButton from "../components/uzum-components/pazaryeri-components/SiparisDetayButton.vue";
import state from "../../store/state";
import Store from "../../store/store";
import { Icon } from "@iconify/vue2";
import barcodeYazdir from "../components/uzum-components/pazaryeri-components/barcodeYazdir.vue";
import CekiListForExcel from "./CekiListForExcel.vue";
import barcodeTumunuYazdir from "../components/uzum-components/pazaryeri-components/barcodeYazdir.vue"
export default {

  data: () => ({
    koliNumber: "",
    verilerForFilter: [],
    excelPopupActive: false,
    auto: null,
    searching: "",
    generatedBarcodes: [], // Yeni eklenen dizi
    inputBarcodes: [], // Add this line for input values
    selectedBarcodeIndex: 0, // Varsayılan olarak ilk barkodu seçili hale getiriyoruz

    orders: [
      { orderNumber: '1005', format: 'CODE128', text: 'Cras justo odio' },

    ],
    selected: [],
    selectedRow: null,
    selectedRowKoli: [],
    program: '',
    veriler: [],
    orderNumber: "",
    orderSevkNumber: "",
    select1: "",
    quantity: "",
    value1: '',
    value2: "",
    popupActivo2: false,
    popupActivo: false,
    orderDate: ""
  }),

  methods: {
    resetFilter() {
      this.searching = "";
      this.filterStockList()
    },
    doubleSelection(tr) {
      this.searching = tr.barcode;
      this.filterStockList()
    },
    filterStockList() {
      this.veriler = this.verilerForFilter.filter(post => {
        return post.orderNumber.includes(this.searching) || post.barcode.includes(this.searching) || post.productName.toUpperCase().includes(this.searching.toUpperCase());
      });
    },
    toggleDataSidebar(val = false) {
      this.excelPopupActive = val
    },
    cekiListForExcel() {
      this.excelPopupActive = true
    },
    formatTarih(tarih) {
      if (typeof tarih !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(tarih)) {
        return tarih;
      }

      const tarihObjesi = new Date(tarih);
      const formatliTarih = `${tarihObjesi.getDate()}.${tarihObjesi.getMonth() + 1}.${tarihObjesi.getFullYear()} `;

      return formatliTarih;
    },
    barkodPopup(tr) {
      this.selectedRow = tr;
      this.popupActivo = true;

    },
    kaydetBarcode(index) {
      if (this.inputBarcodes.length > 0) {

      }
    },
    printAllBarcodes() {
      this.$refs.barcodeYazdir.yazdirAll();
    },

    printBarcode(index, tr, sb) {
      if (index != "control") { 
        this.selectedBarcodeIndex = index; 
        this.koliNumber = this.selectedRow.KoliBarcodesNumber[this.selectedBarcodeIndex]
        this.$refs.barcodeYazdir.yazdir(index + 1);
      }
      else { 
        this.selectedRow = tr
        this.koliNumber = sb
        this.$refs.barcodeYazdir.yazdir(index + 1);
      }
    },
    getBarcodeHeader(index) {

      return `Koli Numarası:  ${index + 1}`;

    },
    addCekiList2(tr) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      let maxVal = Math.max.apply(Math, tr.KoliBarcodesNumber);


      if (tr.siparisOnay == 0 || tr.siparisOnay == "") { }
      else {
        // Include custom barcodes for the current line
        var args = {
          orderNumber: tr.orderNumber,
          marketplace: "Evidea",
          token: Store.state.tokenId,
          productCode: tr.sku,
          barcode: tr.barcode,
          quantity: tr.quantity,
          sendedQuantity: tr.siparisOnay,
          koliAdet: tr.KoliAdetDeger,
          koliIci: tr.KoliAdet,
          orderDate: vm.orderDate,
          sevkNumber: vm.orderSevkNumber,
          cargoTagNumber: JSON.stringify(tr.KoliBarcodesNumber).replace("[", "").replace("]", "").replace('"', ""),
          sonKoliNumber: maxVal,
        };
        /*   if (tr.siparisOnay == 0 || tr.siparisOnay == "") {
             args = {
               orderNumber: tr.orderNumber,
               marketplace: "Evidea",
               token: Store.state.tokenId,
               productCode: tr.sku,
               barcode: tr.barcode,
               quantity: tr.quantity,
               sendedQuantity: "",
               koliAdet: "",
               koliIci: tr.koliIci,
               sevkNumber: vm.orderSevkNumber,
               cargoTagNumber: "",
               sonKoliNumber: tr.sonKoli
             };
           }*/

        soap.createClient(url, function (err, client) {
          client.cekiListesiKaydet(args, function (err, result) {
            if (result.cekiListesiKaydetResult == "-1") {
              Store.dispatch("logout");
            } else {
              try {
                vs.loading.close("#button-with-loading > .con-vs-loading");
                let deger = JSON.parse(result.cekiListesiKaydetResult);
                vm.siparisDetay();
                vm.selectedRow = tr
                vm.$refs.barcodeYazdir.yazdirAll();
              } catch (error) {
                if (error.toString().includes("focus")) {
                  vs.loading.close("#button-with-loading > .con-vs-loading");
                } else {
                  vs.loading.close("#button-with-loading > .con-vs-loading");
                }
              }
            }
          });
        });
      }

    },


    islemiTamamla() {
      let type = "radius";
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        container: "#button-with-loading",
        type
      });

      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        marketplace: "Evidea",
        token: Store.state.tokenId,
        sevkNumber: vm.orderSevkNumber,
        orderDate: vm.orderDate,
        durum: 2
      };


      soap.createClient(url, function (err, client) {
        client.cekiListesiKaydet(args, function (err, result) {
          if (result.cekiListesiKaydetResult == "-1") {
            Store.dispatch("logout");
          } else {
            try {
              vs.loading.close("#button-with-loading > .con-vs-loading");
              let deger = JSON.parse(result.cekiListesiKaydetResult);
              vm.siparisDetay();
            } catch (error) {
              if (error.toString().includes("focus")) {
                vs.loading.close("#button-with-loading > .con-vs-loading");
              } else {
                vs.loading.close("#button-with-loading > .con-vs-loading");
              }
            }
          }
        });
      });

    },

    generateBarcode(orderNumber, barcode, indextr) {

      // Sipariş numarasına son beş karakteri ve indeksi ekle
      const lastFiveCharacters = barcode.slice(-5);
      const KoliorderNumber = orderNumber.slice(-5);

      // Sadece seçili satırın barkodunu kullanarak özel bir barcode oluştur
      const uniqueBarcodeValue = `${KoliorderNumber}-${lastFiveCharacters}-${indextr}`;
      this.$set(this.inputBarcodes, indextr, uniqueBarcodeValue);

      // Oluşturulan barkod değerini döndür
      return uniqueBarcodeValue;
    },
    yuvarla(quantity) {
      let rrValue
      if (Number.isInteger(quantity)) {
        rrValue = quantity;
      } else {
        rrValue = Math.ceil(quantity);
      }
      if (isNaN(rrValue)) rrValue = 0
      return rrValue
    },

    yuvarlananVeCarpilan(quantity, select1, index) {
      if (select1 > 0) {
        const calculatedValue = quantity / select1;
        if (Number.isInteger(calculatedValue)) {
          this.roundedValue = calculatedValue;
        } else {
          this.roundedValue = Math.ceil(calculatedValue);
        }
        if (isNaN(this.roundedValue)) this.roundedValue = 0
        if (isNaN(select1)) select1 = 0

        //this.$set(this.veriler, index, { ...this.veriler[index], KoliAdetDeger: this.roundedValue });
        this.veriler[index].KoliAdetDeger = this.roundedValue
        this.inputBarcodes = []

        this.veriler.forEach((veri, index) => {
          const koliAdetDeger = veri.KoliAdetDeger;
          this.generatedBarcodes = [];
          this.generatedBarcodesNumber = [];

          for (let i = 0; i < koliAdetDeger; i++) {
            const generatedBarcode = this.generateBarcode(this.orderNumber.slice(-5), veri.barcode, i + 1);
            this.generatedBarcodes.push(generatedBarcode);
            this.generatedBarcodesNumber.push(parseInt(veri.sonKoli) + i + 1)
          }
          this.veriler[index].KoliBarcodes = this.generatedBarcodes
          this.veriler[index].KoliBarcodesNumber = this.generatedBarcodesNumber


        });
      }

    },
    openPopup(tr) {
      this.selectedRowKoli = tr;
      this.orderNumber = tr.orderNumber;
      this.popupActivo2 = true;
    },
    popupClose() {
      this.popupActivo2 = false;

    },

    handleSelectedRow(tr) {
      // Access the data of the selected row using tr
      if (tr && tr.barcode) {
        // Perform your actions using tr
        // Add your additional actions here using the selected row data
        //this.gonder(tr.barcode, tr.quantity);
        this.selectedRow = tr
      }
    },

    gonder(tr) {
      // select1 değerini kontrol et
      if (typeof this.select1 !== 'undefined' && this.select1 !== null && this.select1 !== '') {
        // result değerini data içindeki ilgili satıra ekle
        const index = this.veriler.findIndex(item => item.barcode === this.selectedRow.barcode && item.orderNumber === this.selectedRow.orderNumber);
        let qty = this.veriler[index].kalanAdet
        const calculatedValue = qty > 0 ? this.veriler[index].kalanAdet / this.select1 : this.veriler[index].quantity / this.select1;

        if (index !== -1) {
          if (Number.isInteger(calculatedValue)) {
            // Eğer hesaplanan değer tam sayı ise direkt yazdır
            this.roundedValue = calculatedValue;
          } else {
            // Tam sayı değilse yukarıya doğru yuvarlayarak yazdır
            this.roundedValue = Math.ceil(calculatedValue);
          }

          // Yuvarlanan değeri select1 ile çarpıp yeni değeri inputDeneme'e yazdır
          const newValue = this.roundedValue * this.select1;

          // inputDeneme değerini güncelle
          if (this.veriler[index].siparisOnay == 0)
            this.$set(this.veriler, index, { ...this.veriler[index], siparisOnay: newValue });
          this.$set(this.veriler, index, { ...this.veriler[index], KoliAdet: this.select1 });
          this.yuvarlananVeCarpilan(this.veriler[index].siparisOnay, this.veriler[index].KoliAdet, index)
        }
      } else {
        console.log('select1 is not selected');
      }
    },



    GonderilenMiktar() { },
    hazirlananGonder(tr) {

      var vm = this;
      const vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      let maxVal = Math.max.apply(Math, tr.KoliBarcodesNumber);
      let args = {
        token: Store.state.tokenId,
        stockCode: tr.sku,
        quantity: tr.siparisOnay > tr.quantity ? tr.quantity : tr.siparisOnay,
        orderNumber: tr.orderNumber,
        program: tr.program,
        barcode: tr.barcode,
        koliAdet: JSON.stringify(tr.KoliBarcodesNumber).replace("[", "").replace("]", "").replace('"', ""),
        sonKoliNumber: maxVal,
        sevkNumber: vm.orderSevkNumber
      };
      if (tr.siparisOnay == 0 || tr.siparisOnay == "") {
        args = {
          token: Store.state.tokenId,
          stockCode: tr.sku,
          quantity: tr.siparisOnay > tr.quantity ? tr.quantity : tr.siparisOnay,
          orderNumber: tr.orderNumber,
          program: tr.program,
          barcode: tr.barcode,
          koliAdet: JSON.stringify(tr.KoliBarcodesNumber).replace("[", "").replace("]", "").replace('"', ""),
          sevkNumber: vm.orderSevkNumber
        };
      }

      soap.createClient(url, function (err, client) {
        if (err) { return; }
        client.koliAdetGuncelle(args, function (err, result) {
          if (result.koliAdetGuncelleResult == "-1") {
            Store.dispatch("logout");
          }
          let donus = JSON.parse(result.koliAdetGuncelleResult);
          try {
            if (donus.response == "Ok") {
              vm.siparisDetay();
              vs.notify({
                title: "Ceki adedi Bilgisi",
                text: "Hazırlanan adet kaydedildi.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            } else {
              vs.notify({
                title: "Ceki adedi Bilgisi",
                text: donus,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.notify({
              title: "Ceki adedi Bilgisi",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }

        });
      });

    },
    siparisDetay() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "Evidea",
        token: Store.state.tokenId,
        sevkNumber: vm.orderSevkNumber,
      };

      soap.createClient(url, function (err, client) {
        if (err) {
          return;
        }

        client.SiparisDetay(args, function (err, result) {
          if (result.SiparisDetayResult == "-1") {
            Store.dispatch("logout");
          }

          vm.veriler = JSON.parse(result.SiparisDetayResult);
          vm.verilerForFilter = JSON.parse(result.SiparisDetayResult);
          vm.orderNumber = vm.veriler[0].orderNumber;
          if (vm.searching != "")
            vm.filterStockList()
          vm.veriler.forEach((veri, index) => {
            const koliAdetDeger = veri.KoliAdetDeger;
            vm.generatedBarcodes = [];
            vm.generatedBarcodesNumber = [];

            for (let i = 0; i < koliAdetDeger; i++) {
              const generatedBarcode = vm.generateBarcode(vm.orderNumber.slice(-5), veri.barcode, i + 1);
              vm.generatedBarcodes.push(generatedBarcode);
              vm.generatedBarcodesNumber.push(parseInt(veri.sonKoli) + i + 1)
            }
            vm.veriler[index].KoliBarcodes = vm.generatedBarcodes
            vm.veriler[index].KoliBarcodesNumber = vm.generatedBarcodesNumber

          });

        });
      });
    },


  },
  watch: {

  },
  components: {
    barcodeTumunuYazdir,
    CekiListForExcel,
    KoliEklePopup,
    SiparisDetayButton,
    Icon,
    Barcode,
    barcodeYazdir
  },
  computed: {
    selectedRowBarcode() {
      // Seçili satırın barkodunu döndür 
      if (this.selectedRow) {
        return this.generateBarcode(this.selectedRow.orderNumber.slice(-5), this.selectedRow.barcode);
      }
      return '';
    },
  },


  mounted() {
    this.$root.$on("getCekiDetay", params => {
      this.siparisDetay();
    });
    this.$root.$on("gonderKoliAdet", id => {
      this.select1 = id
      this.gonder();
    });
  },
  beforeDestroy() {
    this.$root.$off("gonderKoliAdet");
    this.$root.$off("getCekiDetay");

  },
  created() {
    this.orderSevkNumber = this.$route.params.orderNumber;
    this.orderDate = this.$route.params.orderDate;

    this.siparisDetay();

  },


};

</script>

<style lang="stylus">
.small {
  font-size: 12px; /* Adjust the font size as needed */
  margin-bottom: 5px; /* Adjust the margin as needed */
}
.th-container
  display: flex
  flex-wrap: wrap

.border-item
  flex: 1
  border: 1px solid #000
  padding: 5px
  margin: 5px

.custom-border
  border: 1px solid #000

.th-container
  .custom-border
    border 1px solid #000
.popup-example
  .vs-input
    float left
    width 50%
    margin 10px
    margin-top 5px
  .con-select
    margin-left 10px
    width 50%
    margin-bottom 10px
</style>